import { MatDateFormats } from "@angular/material/core";

export class TimeConstants {
  static readonly SECOND: string = $localize`:@@second:second`;
  static readonly MINUTE: string = $localize`:@@minute:minute`;
  static readonly HOUR: string = $localize`:@@hour:hour`;
}

export class TimeFormatConstants {
  static readonly SECOND: string = "ss";
  static readonly MINUTE: string = "mm";
  static readonly HOUR: string = "HH";
}

export class DurationConstants {
  static readonly UPTO15: string = $localize`:@@up-to-15-mins:Up to 15 mins`;
  static readonly FIFTEENTO30: string = $localize`:@@15-to-30-mins:15-30 mins`;
  static readonly THIRTYTO60: string = $localize`:@@30-60-mins:30-60 mins`;
  static readonly OVER1HR: string = $localize`:@@over-1-hour:Over 1 hour`;
}

export enum TimeDuration {
  Up_To_15 = "Up to 15 mins",
  Fifteen_To_30 = "15-30 mins",
  Thirthy_To_60 = "30-60 mins",
  Over_1_hour = "Over 1 hour",
}

export const TIME_TAKEN: string[] = [
  TimeDuration.Up_To_15,
  TimeDuration.Fifteen_To_30,
  TimeDuration.Thirthy_To_60,
  TimeDuration.Over_1_hour,
];

export class DateConstants {
  static readonly LOCALE_GB: string = "en-GB";
  static readonly YYYY_MM_DD_HYP: string = "yyyy-MM-dd";
  static readonly DD_MMM_YYYY: string = "dd MMM, YYYY";
  static readonly DD_MMMM_YYYY: string = "DD/MM/YYYY";
  static readonly DD_MM_YYYY: string = "dd/MM/yyyy";
  static readonly REPORT_DATE_FORMAT: string = "d MMM y, h:mm a";
  static readonly REPORT_DATE_COMPLETED_FORMAT: string = "d MMM y";
}

export const DDMMYYYY_FORMAT: MatDateFormats = {
  parse: {
    dateInput: "DD/MM/YYYY",
  },
  display: {
    dateInput: "DD/MM/YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD/MM/YYYY",
    monthYearA11yLabel: "MMMM YYYY",
  },
};
